import { defineStore } from 'pinia'

export const useLookupStore = defineStore('lookup', () => {
  const { t } = useI18n()
  const toast = useToast()

  const lookups: any = reactive({})
  const permissions: any = ref([])
  const loadedLookup = shallowRef(false)
  const getLookup = (name: string) => lookups[name]
  const getLookupItemPerId = (name: string, id: string) => {
    const look = getLookup(name)
    const item = look?.find((e: any) => {
      return id === e.id
    })
    return item?.title || item?.name || item?.code || item?.fullName
  }

  function mergeWithoutOverrideReactive(base: any, extra: any) {
    Object.entries(extra).forEach(([key, value]) => {
      if (!(key in base)) {
        base[key] = value
      }
    })
  }

  const getLookups = async (affix: string) => {
    const toSlash = (str: string) => str.replace('/', '-')
    try {
      const token = localStorage.getItem('token')
      let prefix = 'api/catalog/'
      if(token) {
        const role = parseJwt(token)?.role
        prefix = role === 'admin' ? 'api/admin/catalog/' : 'api/catalog/'
      }

      const response = await useApi(prefix + toSlash(affix), {
        method: 'GET',
      })
      const result = response?.data

      if (result) {
        Object.entries(result).forEach(([key, value]) => {
          if (key === 'permissions') {
            permissions.value = result.permissions
          } else if (key === 'permission' && value) {
            mergeWithoutOverrideReactive(permissions.value, value)
            permissions.value = result.permissions
          } else {
            lookups[key] = value
          }
        })
        loadedLookup.value = true
      }
    } catch (error) {
      const err = error as { status?: number; response?: { status?: number } }
      const status = err?.status || err?.response?.status
      if (status === 404) {
        console.warn(`Lookups not found for "${affix}"`)
        return
      }

      toast.add({
        title: t('forms.errors.title'),
        description: String(error),
        color: 'error',
      })
      console.error('Failed to fetch contacts:', error)
    }
  }

  return {
    lookups,
    getLookup,
    getLookups,
    getLookupItemPerId,
    permissions,
    loadedLookup,
  }
})
